export default __webpack_public_path__ + "static/media/uploader-trivia-problem-1.cc69eb90.png";